<script lang="ts" setup>
import { GlobalProgress, TooltipProvider } from '@dailycare-au/ui'
import { useHead } from '@unhead/vue'

const titleSuffix = 'DailyCare'

useHead({ titleTemplate: title => title ? `${title} ∙ ${titleSuffix}` : titleSuffix })
</script>

<template>
  <GlobalProgress />

  <TooltipProvider ignore-non-keyboard-focus>
    <RouterView />
  </TooltipProvider>
</template>
